import { useState } from 'react';
import { original, rose, vaporwave, matrix } from 'react95/dist/themes';
import { BrowserRouter, Router, Routes, Route, Link, useNavigate} from "react-router-dom";
import { createGlobalStyle, ThemeProvider, createTheme} from 'styled-components';
import {
    AppBar,
  Button,
  MenuList,
  MenuListItem,
  ScrollView,
  Separator,
  Toolbar,
    Frame,
  Window,
    
  WindowContent,
  WindowHeader,
    TextInput,
    styleReset
} from 'react95';

const AboutPage = () => {
    const navigate = useNavigate();
    
    const handleRedirect = (dir) => {
            navigate(dir);
        };
    
  return (
    <ThemeProvider theme={rose}>
          <Window resizable className='window' style={{ display: 'block', height: '80vh', width: 'calc(90vh * (3/2))', maxWidth: "800px"}}>
          <WindowHeader className='window-title' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span>About Page</span>
              <Button style={{ marginRight: '2px', width: '20px', height: '20px', padding: 0 }} onClick={() => handleRedirect('/')}>
              <span style={{ fontWeight: 'bold', fontSize: '12px' }}>✕</span>
              </Button>
            </WindowHeader>

            <WindowContent style={{ height: 'calc(100% - 33px)', padding: 0 }}>
              <Frame variant='well' className='footer' style={{ height: '100%', margin: 0 }}>
                <ScrollView style={{ height: '100%' }}>
                  <div style={{ padding: '1rem' }}>
                    <h1>Who is Xara Neale Shaw?</h1>
                    <p style={{ color: "#c43961" }}>
                      Hey there,
                      <br />
                      <br />
                      My name is Xara Shaw, also known as Xaragame on the interwebs. I am a Los
                      Angeles, CA based game designer, web designer, visual artist, writer and
                      professionally unemployed woman. My main goal with my art is to make
                      boundary pushing mixed media pieces that blur the lines between art, game
                      and entertainment to closely inspect the human condition. In short, I want
                      to make weird shit. My work often examines topics of race, queerness,
                      community, romance and the urban form. I try to really reflect on the
                      world around me in all its beauty and absurdity. I don't know if any of
                      this is making sense, I feel like I sound superfucking pretentious and
                      like an artsy weirdo. Oh well, maybe it's because I am superfucking
                      pretentious and an artsy weirdo.
                      <br />
                      <br />
                      I generally just make whatever project I feel most interested at that
                      moment. I don't really have much rhyme or reason to what I do, however at
                      the moment I do have some general trends in what I do. I've recently been
                      drawing more cartoons and drawings in a series I call "The Valley of the
                      Absurd" with these weird anthropomorphic mice. Additionally, I've been
                      trying to work on my skills in public relations on my TikTok with posts
                      informing people comedically about my local transit agency, Metro. Also,
                      I've been doing a lot more web design work, as evidenced by this website
                      and if you'd like me to do something similar for you then feel free to
                      contact me. I'd love to work something out. Also Lately I've been writing
                      more, especially romance stuff on my scribblehub and here on this website
                      that I think you might enjoy. I'm almost always available for hire or
                      commission so please, do contact me. Until then, enjoy my website, you can
                      find my work in my portfolio. Read my rants on my blog. See what I'm
                      reading, watching, playing or listening to in Media Recommendations. And
                      check out my socials in the taskbar.
                      <br />
                      <br />
                      Thanks,
                      <br />
                      <br />
                      Xara Shaw
                    </p>
                  </div>
                </ScrollView>
              </Frame>
            </WindowContent>
          </Window>
          
          
    </ThemeProvider>
  );
}

export default AboutPage;
